// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfab8018","453":"0121ea0e","455":"43ab3d4e","977":"3a3c2845"}[chunkId] + ".chunk.js";
};